import { render, staticRenderFns } from "./stepUi.vue?vue&type=template&id=7ebdfa26&scoped=true&"
import script from "./stepUi.vue?vue&type=script&lang=js&"
export * from "./stepUi.vue?vue&type=script&lang=js&"
import style0 from "./stepUi.vue?vue&type=style&index=0&id=7ebdfa26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebdfa26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ebdfa26')) {
      api.createRecord('7ebdfa26', component.options)
    } else {
      api.reload('7ebdfa26', component.options)
    }
    module.hot.accept("./stepUi.vue?vue&type=template&id=7ebdfa26&scoped=true&", function () {
      api.rerender('7ebdfa26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/patrolTemplate/photoRecordType/stepUi.vue"
export default component.exports